import React from 'react'
import { Box } from 'designSystem'
import { StyledQCTable, StyledRowHeading, StyledRowColumn } from './styled'

const QCNoteTable = ({ qcNotes = [] }) => {
  return (
    <Box py={8}>
      <h3>QC Notes</h3>
      <StyledQCTable>
        <thead>
          <tr>
            <StyledRowHeading>Time</StyledRowHeading>
            <StyledRowHeading>Issue Type</StyledRowHeading>
            <StyledRowHeading>Category</StyledRowHeading>
            <StyledRowHeading>Remarks</StyledRowHeading>
            <StyledRowHeading>Audio Status</StyledRowHeading>
            <StyledRowHeading>Status</StyledRowHeading>
          </tr>
        </thead>
        <tbody>
          {qcNotes.map((data, index) => (
            <tr key={index}>
              <StyledRowColumn>{data.time || 'N/A'}</StyledRowColumn>
              <StyledRowColumn>{data.issue_type}</StyledRowColumn>
              <StyledRowColumn>{data.category}</StyledRowColumn>
              <StyledRowColumn>{data.remarks || 'N/A'}</StyledRowColumn>
              <StyledRowColumn>{data.audio_status || 'N/A'}</StyledRowColumn>
              <StyledRowColumn>{data.status || 'N/A'}</StyledRowColumn>
            </tr>
          ))}
        </tbody>
      </StyledQCTable>
    </Box>
  )
}

export default QCNoteTable
